export default __webpack_public_path__ + "static/media/Google IT Support Professional Certificate.08482f49.webp";